module.exports = __webpack_public_path__ + "static/media/Take Up Rollers 4.36b1a1f7.jpg";